import { ListingTag } from '__generated__/athena/graphql';
import type { MarketplaceProperty } from 'components/marketplace/property/types';

type BuyDirectEligibilityInput = Pick<MarketplaceProperty, 'listingTags'>;

export const isBuyDirectEligible = (property: BuyDirectEligibilityInput): boolean => {
  return property.listingTags.includes(ListingTag.BUY_DIRECT_ELIGIBLE);
};
